import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `ContentRoot`,
  choices: `ContentChoices`
};

export function useContentStyles() {
  const { effects, semanticColors, spacing } = useTheme();
  const styleSet = useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`,
          padding: `0 5px 0 2px`
        }
      ],
      choices: [
        classNames.choices,
        {
          height: `100%`,
          "& .ms-ChoiceField, & .ms-ChoiceField-wrapper, & .ms-ChoiceField-field": {
            width: `100%`
          },
          "& .ms-ChoiceField": {
            boxShadow: effects.elevation4,
            padding: `15px`
          },
          "& .ms-ChoiceField:first-child": {
            backgroundColor: semanticColors.listItemBackgroundChecked,
            marginBottom: spacing.l2
          }
        }
      ]
    }),
    [effects, semanticColors, spacing]
  );
  return styleSet;
}
